import { gql, useQuery } from "@apollo/client";
import { campaignByIdQueryQuery, CampaignByIdQuery } from "__generated__/api";
import CampaignRecommendations = CampaignByIdQuery.CampaignRecommendations;

const campaignByIdQuery = gql`
  ${campaignByIdQueryQuery}
`;

export type CampaignByIdResponse = { campaignRecommendations: CampaignRecommendations };

export function useCampaignByIdQuery(variables: CampaignByIdQuery.Variables) {
  return useQuery<CampaignByIdResponse>(campaignByIdQuery, {
    variables,
    ssr: false,
  });
}

export default useCampaignByIdQuery;
